import type { ApiResponse } from '@kangaroo/shared';

import { api } from '../lib/api';

export async function redeemSessionScan(locator: string) {
  const response = await api.post<ApiResponse<{ sessionId: string }>>(
    `/session-scans/v1/${locator}/redeem`,
  );
  return response.data.data;
}
